import React, { useEffect, useState } from "react";
import {
  Card,
  CardBody,
  Container,
  Row,
  Col,
  Form,
  FormGroup,
  Label,
  Input,
  Button,
  Spinner,
} from "reactstrap";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { getSettings, updateSetting } from "../../api/ecommerce";

const StripeSettings = () => {
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [stripePublishableKey, setStripePublishableKey] = useState("");
  const [stripeSecretKey, setStripeSecretKey] = useState("");

  useEffect(() => {
    getSettings()
      .then((res) => {
        const data = res?.data || res;
        setStripePublishableKey(data?.stripe_publishable_key || "");
        setStripeSecretKey(data?.stripe_secret_key || "");
      })
      .catch(() => {
        toast.error("Failed to load settings");
      })
      .finally(() => setLoading(false));
  }, []);

  const handleSave = async () => {
    setSaving(true);
    try {
      await updateSetting("stripe_publishable_key", stripePublishableKey);
      await updateSetting("stripe_secret_key", stripeSecretKey);
      toast.success("Stripe settings saved successfully");
    } catch (err) {
      toast.error(err?.message || "Failed to save settings");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="page-content">
      <Container fluid>
        <BreadCrumb title="Stripe Settings" pageTitle="Website" />
        <Row>
          <Col lg={8}>
            <Card>
              <CardBody>
                <h5 className="card-title mb-4">Stripe Payment Gateway</h5>
                <p className="text-muted">
                  Add your Stripe API keys to enable online payments on the checkout page.
                  Get your keys from{" "}
                  <a
                    href="https://dashboard.stripe.com/apikeys"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Stripe Dashboard
                  </a>
                  .
                </p>
                {loading ? (
                  <div className="text-center py-4">
                    <Spinner />
                  </div>
                ) : (
                  <Form>
                    <FormGroup>
                      <Label for="stripePublishableKey">Publishable Key</Label>
                      <Input
                        type="text"
                        id="stripePublishableKey"
                        value={stripePublishableKey}
                        onChange={(e) => setStripePublishableKey(e.target.value)}
                        placeholder="pk_test_..."
                      />
                      <small className="text-muted">Used on the frontend (website) for Stripe Elements.</small>
                    </FormGroup>
                    <FormGroup>
                      <Label for="stripeSecretKey">Secret Key</Label>
                      <Input
                        type="password"
                        id="stripeSecretKey"
                        value={stripeSecretKey}
                        onChange={(e) => setStripeSecretKey(e.target.value)}
                        placeholder="sk_test_..."
                      />
                      <small className="text-muted">Used on the backend. Keep this private.</small>
                    </FormGroup>
                    <Button color="primary" onClick={handleSave} disabled={saving}>
                      {saving ? <Spinner size="sm" className="me-2" /> : null}
                      Save Settings
                    </Button>
                  </Form>
                )}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
      <ToastContainer position="top-right" autoClose={3000} />
    </div>
  );
};

export default StripeSettings;
